import * as z from 'zod/v4';
import { GAME_SERVERS_ENUM_RESOURCES } from './consts';
import { validationSchema } from '../../types/validation';
import { ENVIRONMENTS_NAMES } from '../../types/environments';

export const gameServersEnumsTypes = z.enum(GAME_SERVERS_ENUM_RESOURCES);

export const getEnumSchema = validationSchema({
  params: z.object({
    enumType: gameServersEnumsTypes,
    env: z.enum(ENVIRONMENTS_NAMES),
  }),
  response: {
    200: z.object({
      values: z.array(
        z.object({
          label: z.string(),
          value: z.string(),
        }),
      ),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});
